/**
 * sidebar-cta-variant.js — swap the sidebar CTA between the secondary
 * (light) and primary (dark) variants based on scroll position.
 *
 * In the hero: secondary fill (matches the light hero bg).
 * Once the "Unifying Fragmented Compliance Operations" section (#product)
 * scrolls into view: primary fill (dark slate-950, stands out against the
 * rest of the page).
 *
 * The button keeps the same internal structure + hover animations; only
 * the `btn-secondary` / `btn-primary` class swaps. The base button CSS
 * has a `background/color/border-color` transition so the swap animates
 * smoothly.
 */

function setupSidebarCtaVariant() {
  const cta = document.querySelector('[data-cta-variant]');
  // Swap to primary as soon as the "Unifying" (#product) section starts
  // entering the viewport — its top edge crosses below the viewport top.
  const trigger = document.querySelector('#product');
  if (!cta || !trigger) return;

  let isPrimary = false;
  const update = () => {
    const inOrPast = trigger.getBoundingClientRect().top < window.innerHeight * 0.5;
    if (inOrPast === isPrimary) return; // no state change
    isPrimary = inOrPast;
    if (inOrPast) {
      cta.classList.remove('btn-secondary');
      cta.classList.add('btn-primary');
    } else {
      cta.classList.remove('btn-primary');
      cta.classList.add('btn-secondary');
    }
  };

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupSidebarCtaVariant);
} else {
  setupSidebarCtaVariant();
}
